function getParameterByName(t, e) {
  e || (e = window.location.href), (t = t.replace(/[\[\]]/g, "\\$&"));
  var i = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)"),
    o = i.exec(e);
  return o ? (o[2] ? decodeURIComponent(o[2].replace(/\+/g, " ")) : "") : null;
}
!(function() {
  "use strict";
  function t(o) {
    if (!o) throw new Error("No options passed to Waypoint constructor");
    if (!o.element)
      throw new Error("No element option passed to Waypoint constructor");
    if (!o.handler)
      throw new Error("No handler option passed to Waypoint constructor");
    (this.key = "waypoint-" + e),
      (this.options = t.Adapter.extend({}, t.defaults, o)),
      (this.element = this.options.element),
      (this.adapter = new t.Adapter(this.element)),
      (this.callback = o.handler),
      (this.axis = this.options.horizontal ? "horizontal" : "vertical"),
      (this.enabled = this.options.enabled),
      (this.triggerPoint = null),
      (this.group = t.Group.findOrCreate({
        name: this.options.group,
        axis: this.axis
      })),
      (this.context = t.Context.findOrCreateByElement(this.options.context)),
      t.offsetAliases[this.options.offset] &&
        (this.options.offset = t.offsetAliases[this.options.offset]),
      this.group.add(this),
      this.context.add(this),
      (i[this.key] = this),
      (e += 1);
  }
  var e = 0,
    i = {};
  (t.prototype.queueTrigger = function(t) {
    this.group.queueTrigger(this, t);
  }),
    (t.prototype.trigger = function(t) {
      this.enabled && this.callback && this.callback.apply(this, t);
    }),
    (t.prototype.destroy = function() {
      this.context.remove(this), this.group.remove(this), delete i[this.key];
    }),
    (t.prototype.disable = function() {
      return (this.enabled = !1), this;
    }),
    (t.prototype.enable = function() {
      return this.context.refresh(), (this.enabled = !0), this;
    }),
    (t.prototype.next = function() {
      return this.group.next(this);
    }),
    (t.prototype.previous = function() {
      return this.group.previous(this);
    }),
    (t.invokeAll = function(t) {
      var e = [];
      for (var o in i) e.push(i[o]);
      for (var n = 0, r = e.length; n < r; n++) e[n][t]();
    }),
    (t.destroyAll = function() {
      t.invokeAll("destroy");
    }),
    (t.disableAll = function() {
      t.invokeAll("disable");
    }),
    (t.enableAll = function() {
      t.Context.refreshAll();
      for (var e in i) i[e].enabled = !0;
      return this;
    }),
    (t.refreshAll = function() {
      t.Context.refreshAll();
    }),
    (t.viewportHeight = function() {
      return window.innerHeight || document.documentElement.clientHeight;
    }),
    (t.viewportWidth = function() {
      return document.documentElement.clientWidth;
    }),
    (t.adapters = []),
    (t.defaults = {
      context: window,
      continuous: !0,
      enabled: !0,
      group: "default",
      horizontal: !1,
      offset: 0
    }),
    (t.offsetAliases = {
      "bottom-in-view": function() {
        return this.context.innerHeight() - this.adapter.outerHeight();
      },
      "right-in-view": function() {
        return this.context.innerWidth() - this.adapter.outerWidth();
      }
    }),
    (window.Waypoint = t);
})(),
  (function() {
    "use strict";
    function t(t) {
      window.setTimeout(t, 1e3 / 60);
    }
    function e(t) {
      (this.element = t),
        (this.Adapter = n.Adapter),
        (this.adapter = new this.Adapter(t)),
        (this.key = "waypoint-context-" + i),
        (this.didScroll = !1),
        (this.didResize = !1),
        (this.oldScroll = {
          x: this.adapter.scrollLeft(),
          y: this.adapter.scrollTop()
        }),
        (this.waypoints = { vertical: {}, horizontal: {} }),
        (t.waypointContextKey = this.key),
        (o[t.waypointContextKey] = this),
        (i += 1),
        n.windowContext ||
          ((n.windowContext = !0), (n.windowContext = new e(window))),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler();
    }
    var i = 0,
      o = {},
      n = window.Waypoint,
      r = window.onload;
    (e.prototype.add = function(t) {
      var e = t.options.horizontal ? "horizontal" : "vertical";
      (this.waypoints[e][t.key] = t), this.refresh();
    }),
      (e.prototype.checkEmpty = function() {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
          e = this.Adapter.isEmptyObject(this.waypoints.vertical),
          i = this.element == this.element.window;
        t && e && !i && (this.adapter.off(".waypoints"), delete o[this.key]);
      }),
      (e.prototype.createThrottledResizeHandler = function() {
        function t() {
          e.handleResize(), (e.didResize = !1);
        }
        var e = this;
        this.adapter.on("resize.waypoints", function() {
          e.didResize || ((e.didResize = !0), n.requestAnimationFrame(t));
        });
      }),
      (e.prototype.createThrottledScrollHandler = function() {
        function t() {
          e.handleScroll(), (e.didScroll = !1);
        }
        var e = this;
        this.adapter.on("scroll.waypoints", function() {
          (e.didScroll && !n.isTouch) ||
            ((e.didScroll = !0), n.requestAnimationFrame(t));
        });
      }),
      (e.prototype.handleResize = function() {
        n.Context.refreshAll();
      }),
      (e.prototype.handleScroll = function() {
        var t = {},
          e = {
            horizontal: {
              newScroll: this.adapter.scrollLeft(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left"
            },
            vertical: {
              newScroll: this.adapter.scrollTop(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up"
            }
          };
        for (var i in e) {
          var o = e[i],
            n = o.newScroll > o.oldScroll,
            r = n ? o.forward : o.backward;
          for (var s in this.waypoints[i]) {
            var a = this.waypoints[i][s];
            if (null !== a.triggerPoint) {
              var l = o.oldScroll < a.triggerPoint,
                h = o.newScroll >= a.triggerPoint,
                p = l && h,
                c = !l && !h;
              (p || c) && (a.queueTrigger(r), (t[a.group.id] = a.group));
            }
          }
        }
        for (var d in t) t[d].flushTriggers();
        this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll };
      }),
      (e.prototype.innerHeight = function() {
        return this.element == this.element.window
          ? n.viewportHeight()
          : this.adapter.innerHeight();
      }),
      (e.prototype.remove = function(t) {
        delete this.waypoints[t.axis][t.key], this.checkEmpty();
      }),
      (e.prototype.innerWidth = function() {
        return this.element == this.element.window
          ? n.viewportWidth()
          : this.adapter.innerWidth();
      }),
      (e.prototype.destroy = function() {
        var t = [];
        for (var e in this.waypoints)
          for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]);
        for (var o = 0, n = t.length; o < n; o++) t[o].destroy();
      }),
      (e.prototype.refresh = function() {
        var t,
          e = this.element == this.element.window,
          i = e ? void 0 : this.adapter.offset(),
          o = {};
        this.handleScroll(),
          (t = {
            horizontal: {
              contextOffset: e ? 0 : i.left,
              contextScroll: e ? 0 : this.oldScroll.x,
              contextDimension: this.innerWidth(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
              offsetProp: "left"
            },
            vertical: {
              contextOffset: e ? 0 : i.top,
              contextScroll: e ? 0 : this.oldScroll.y,
              contextDimension: this.innerHeight(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
              offsetProp: "top"
            }
          });
        for (var r in t) {
          var s = t[r];
          for (var a in this.waypoints[r]) {
            var l,
              h,
              p,
              c,
              d,
              u = this.waypoints[r][a],
              f = u.options.offset,
              w = u.triggerPoint,
              y = 0,
              g = null == w;
            u.element !== u.element.window &&
              (y = u.adapter.offset()[s.offsetProp]),
              "function" == typeof f
                ? (f = f.apply(u))
                : "string" == typeof f &&
                  ((f = parseFloat(f)),
                  u.options.offset.indexOf("%") > -1 &&
                    (f = Math.ceil((s.contextDimension * f) / 100))),
              (l = s.contextScroll - s.contextOffset),
              (u.triggerPoint = Math.floor(y + l - f)),
              (h = w < s.oldScroll),
              (p = u.triggerPoint >= s.oldScroll),
              (c = h && p),
              (d = !h && !p),
              !g && c
                ? (u.queueTrigger(s.backward), (o[u.group.id] = u.group))
                : !g && d
                ? (u.queueTrigger(s.forward), (o[u.group.id] = u.group))
                : g &&
                  s.oldScroll >= u.triggerPoint &&
                  (u.queueTrigger(s.forward), (o[u.group.id] = u.group));
          }
        }
        return (
          n.requestAnimationFrame(function() {
            for (var t in o) o[t].flushTriggers();
          }),
          this
        );
      }),
      (e.findOrCreateByElement = function(t) {
        return e.findByElement(t) || new e(t);
      }),
      (e.refreshAll = function() {
        for (var t in o) o[t].refresh();
      }),
      (e.findByElement = function(t) {
        return o[t.waypointContextKey];
      }),
      (window.onload = function() {
        r && r(), e.refreshAll();
      }),
      (n.requestAnimationFrame = function(e) {
        (
          window.requestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          t
        ).call(window, e);
      }),
      (n.Context = e);
  })(),
  (function() {
    "use strict";
    function t(t, e) {
      return t.triggerPoint - e.triggerPoint;
    }
    function e(t, e) {
      return e.triggerPoint - t.triggerPoint;
    }
    function i(t) {
      (this.name = t.name),
        (this.axis = t.axis),
        (this.id = this.name + "-" + this.axis),
        (this.waypoints = []),
        this.clearTriggerQueues(),
        (o[this.axis][this.name] = this);
    }
    var o = { vertical: {}, horizontal: {} },
      n = window.Waypoint;
    (i.prototype.add = function(t) {
      this.waypoints.push(t);
    }),
      (i.prototype.clearTriggerQueues = function() {
        this.triggerQueues = { up: [], down: [], left: [], right: [] };
      }),
      (i.prototype.flushTriggers = function() {
        for (var i in this.triggerQueues) {
          var o = this.triggerQueues[i],
            n = "up" === i || "left" === i;
          o.sort(n ? e : t);
          for (var r = 0, s = o.length; r < s; r += 1) {
            var a = o[r];
            (a.options.continuous || r === o.length - 1) && a.trigger([i]);
          }
        }
        this.clearTriggerQueues();
      }),
      (i.prototype.next = function(e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints);
        return i === this.waypoints.length - 1 ? null : this.waypoints[i + 1];
      }),
      (i.prototype.previous = function(e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints);
        return i ? this.waypoints[i - 1] : null;
      }),
      (i.prototype.queueTrigger = function(t, e) {
        this.triggerQueues[e].push(t);
      }),
      (i.prototype.remove = function(t) {
        var e = n.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1);
      }),
      (i.prototype.first = function() {
        return this.waypoints[0];
      }),
      (i.prototype.last = function() {
        return this.waypoints[this.waypoints.length - 1];
      }),
      (i.findOrCreate = function(t) {
        return o[t.axis][t.name] || new i(t);
      }),
      (n.Group = i);
  })(),
  (function() {
    "use strict";
    function t(t) {
      this.$element = e(t);
    }
    var e = window.jQuery,
      i = window.Waypoint;
    e.each(
      [
        "innerHeight",
        "innerWidth",
        "off",
        "offset",
        "on",
        "outerHeight",
        "outerWidth",
        "scrollLeft",
        "scrollTop"
      ],
      function(e, i) {
        t.prototype[i] = function() {
          var t = Array.prototype.slice.call(arguments);
          return this.$element[i].apply(this.$element, t);
        };
      }
    ),
      e.each(["extend", "inArray", "isEmptyObject"], function(i, o) {
        t[o] = e[o];
      }),
      i.adapters.push({ name: "jquery", Adapter: t }),
      (i.Adapter = t);
  })(),
  (function() {
    "use strict";
    function t(t) {
      return function() {
        var i = [],
          o = arguments[0];
        return (
          t.isFunction(arguments[0]) &&
            ((o = t.extend({}, arguments[1])), (o.handler = arguments[0])),
          this.each(function() {
            var n = t.extend({}, o, { element: this });
            "string" == typeof n.context &&
              (n.context = t(this).closest(n.context)[0]),
              i.push(new e(n));
          }),
          i
        );
      };
    }
    var e = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
      window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto));
  })(),
  (function() {
    "use strict";
    function t(o) {
      (this.options = e.extend({}, i.defaults, t.defaults, o)),
        (this.element = this.options.element),
        (this.$element = e(this.element)),
        this.createWrapper(),
        this.createWaypoint();
    }
    var e = window.jQuery,
      i = window.Waypoint;
    (t.prototype.createWaypoint = function() {
      var t = this.options.handler;
      this.waypoint = new i(
        e.extend({}, this.options, {
          element: this.wrapper,
          handler: e.proxy(function(e) {
            var i = this.options.direction.indexOf(e) > -1,
              o = i ? this.$element.outerHeight(!0) : "";
            this.$wrapper.height(o),
              this.$element.toggleClass(this.options.stuckClass, i),
              t && t.call(this, e);
          }, this)
        })
      );
    }),
      (t.prototype.createWrapper = function() {
        this.options.wrapper && this.$element.wrap(this.options.wrapper),
          (this.$wrapper = this.$element.parent()),
          (this.wrapper = this.$wrapper[0]);
      }),
      (t.prototype.destroy = function() {
        this.$element.parent()[0] === this.wrapper &&
          (this.waypoint.destroy(),
          this.$element.removeClass(this.options.stuckClass),
          this.options.wrapper && this.$element.unwrap());
      }),
      (t.defaults = {
        wrapper: '<div class="sticky-wrapper" />',
        stuckClass: "stuck",
        direction: "down right"
      }),
      (i.Sticky = t);
  })(),
  $(document).ready(function() {
    !(function() {
      if (
        ($(".main").waypoint(function() {
          $(".header2").is(":hidden")
            ? $(".header2").slideDown(100)
            : $(".header2").slideUp(100);
        }),
        $(".scrolltoform").on("click", function(t) {
          t.preventDefault();
          var e = $(this).attr("href"),
            i = $(".header2").height() + 20;
          $("html, body").animate({ scrollTop: $(e).offset().top - i }, 2e3);
        }),
        window.location.hash)
      ) {
        var t = window.location.hash,
          e = $(".header2").height() + 20;
        $("html, body").animate({ scrollTop: $(t).offset().top - e }, 2e3);
      }
    })(),
      "lasoo" == getParameterByName("source") &&
        ($(".announcement").hide(),
        $("#shopify-section-header").hide(),
        $("#shopify-section-footer").hide(),
        $("#shopify-section-age-checker").hide(),
        $("#shopify-section-promo-pop").hide());
  });

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function suggestionsTemplate(data) {
  var $template = $("<div class='o-layout u-flex'></div>");
  var datasets = ["collection", "product", "page", "article"];
  if (data.results_count > 0) {
    $(datasets).each(function(i, dataset) {
      if (data[dataset].length) {
        var $suggestionsList = suggestionsList(data[dataset], dataset + "s");
        $template.append($suggestionsList);
      }
    });
  } else {
    $template.append(
      "<div class='o-layout__item u-1/1'><h3>No search suggestions found</h3></div>"
    );
  }

  return $template;
}

function suggestionsList(data, title) {
  var $template = $(
    "<div class='o-layout__item u-1/2@desk search-autocomplete__column'><h4>" +
      title +
      "</h4><ul></ul></div>"
  );
  $(data).each(function(i, line) {
    var $lineTemplate = suggestionTemplate(line);
    $($template.find("ul")).append($lineTemplate);
  });
  return $template;
}

function suggestionTemplate(object) {
  return $("<li><a href='" + object.url + "'>" + object.title + "</a></li>");
}

function newAutocomplete() {
  var $input = $(".js-search-input");
  var $suggestionArea = $(".js-search-draw .search__nav");
  var $button = $(".js-search-draw .search__form-submit");
  $button.append("<div class='spinner' style='display: none'></div>");

  var results = [];

  var $getSuggestions = debounce(function(term) {
    $($button.find(".icon")).hide();
    $($button.find(".spinner")).show();
    $.ajax("/search?view=json&q=*" + term + "*", {
      dataType: "json",
      success: function(response) {
        results = response.results;
        $template = suggestionsTemplate(results);
        $suggestionArea.html($template);
        $($button.find(".icon")).show();
        $($button.find(".spinner")).hide();
      }
    });
  }, 350);

  $input.on("input", function() {
    $getSuggestions($input.val());
  });
}

$("document").ready(newAutocomplete);


function swiperCallback(entries) {
  if (window.innerWidth < 768) {
    entries.forEach(function(entry) {
      var newOpacity = entry.intersectionRatio > 0.1 ? (entry.intersectionRatio * 0.8 + 0.32).toPrecision(2) : 0.4;

      entry.target.style.opacity = newOpacity;
    });
  } else {
    entries.forEach(function(entry) {
      if (entry.target.style.opacity != 1){
        entry.target.style.opacity = 1;
      }
    });
  }

}
if (!!window.IntersectionObserver) {
  var swiperArticles = document.querySelectorAll(".mobile-swiper article");
  var thresholds = [];
  for (var t = 0.1; t <= 0.86; t +=0.02) {
    thresholds.push(t);
  }
  var observer = new IntersectionObserver(swiperCallback, {
    threshold: thresholds,
    rootMargin: "600px 0px"
  });

  for(var i = 0; i < swiperArticles.length; i ++) {
    var article = swiperArticles[i];
    observer.observe(article);
  }
}


$(".afterpay-popup-launcher").magnificPopup({
  closeMarkup: '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp"><i class="icon icon--close"></i></button>'
});


var storeLocator = {
  stores: [],
  storeId: 4216,
  states: ["ACT", "NSW", "NT", "QLD", "SA", "VIC", "WA"],
  apiKey: "AIzaSyBFvJdc5PTpgyb91SmeJ10s6lMsbfhUBiw",
  accordion: $(".map-accordion"),
  filters: $(".store-locator-filters button"),
  filterHeading: $(".store-locator-filters h2"),
  filterStates: $(".store-locator-filters-states"),
  form: $(".store-locator-body form"),
  input: $(".store-locator-input"),
  storeHoursEndpoint: "/pages/airport-west",
  map: null,
  markers: [],
  maxResults: 5,
  init: function() {
    this.fetchStores();
    this.fetchStoreHours();
    this.initMap();
    this.initButtons();
    this.initSearch();
    return this;
  },
  fetchStores: function() {
    $.ajax(
      "https://storemapper-herokuapp-com.global.ssl.fastly.net/api/users/" +
        this.storeId +
        "/stores.js",
      {
        dataType: "json",
        success: function(resp) {
          storeLocator.setStores(resp.stores);
          if (storeLocator.storeHours) {
            storeLocator.initAccordion(storeLocator.stores);
          }
        }
      }
    );
  },
  fetchStoreHours: function() {
    $.ajax(this.storeHoursEndpoint, {
      success: function(resp) {
        var data = $(resp).find("#stores-data");
        storeLocator.storeHours = JSON.parse(data.text());
        if (storeLocator.stores && storeLocator.stores.length > 0) {
          storeLocator.initAccordion(storeLocator.stores);
        }
      }
    });
  },
  initMap: function() {
    var head = document.querySelector("head");
    var script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?libraries=geometry&key=" +
      this.apiKey;
    script.addEventListener("load", function() {
      if ($(window).width() > 767) {
        storeLocator.map = new google.maps.Map(document.getElementById("map"), {
          center: { lat: -34.397, lng: 150.644 },
          disableDefaultUI: true,
          zoomControl: true,
          styles: [
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#d3d3d3"
                }
              ]
            },
            {
              featureType: "transit",
              stylers: [
                {
                  color: "#808080"
                },
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [
                {
                  visibility: "on"
                },
                {
                  color: "#b3b3b3"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#ffffff"
                }
              ]
            },
            {
              featureType: "road.local",
              elementType: "geometry.fill",
              stylers: [
                {
                  visibility: "on"
                },
                {
                  color: "#ffffff"
                },
                {
                  weight: 1.8
                }
              ]
            },
            {
              featureType: "road.local",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#d7d7d7"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "geometry.fill",
              stylers: [
                {
                  visibility: "on"
                },
                {
                  color: "#ebebeb"
                }
              ]
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [
                {
                  color: "#a7a7a7"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#ffffff"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#ffffff"
                }
              ]
            },
            {
              featureType: "landscape",
              elementType: "geometry.fill",
              stylers: [
                {
                  visibility: "on"
                },
                {
                  color: "#efefef"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#696969"
                }
              ]
            },
            {
              featureType: "administrative",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "on"
                },
                {
                  color: "#737373"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "labels",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#d6d6d6"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#dadada"
                }
              ]
            }
          ],
          zoom: 8
        });
        storeLocator.initMarkers(storeLocator.stores);
      }
    });
    head.appendChild(script);
  },
  initMarkers: function(stores) {
    if (this.map && stores.length > 0) {
      this.infowindow = new google.maps.InfoWindow();
      stores.forEach(function(store) {
        var marker = new google.maps.Marker({
          position: { lat: store.latitude, lng: store.longitude },
          map: storeLocator.map,
          state: store.state,
          id: store.id,
          icon: window.map_marker,
          content:
            "<div class='map-infowindow-content' style='color:black'>" +
            "<h3 class='fancy-title'>" +
            store.name +
            "</h3>" +
            "<ul class='store-locator-data'>" +
            "<li><a><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'><use href='#phone'></svg>" +
            store.phone +
            "</a></li>" +
            "<li><address><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'><use href='#locator-pin'></svg>" +
            store.address +
            "</address></li>" +
            "</ul>" +
            "<a class='c-btn c-btn--ghost_2' href='" +
            store.custom_field_1 +
            "'>" +
            "View Store" +
            "</a>" +
            "</div>"
        });
        marker.addListener("click", function() {
          storeLocator.openInfowindow(marker);
        });
        storeLocator.markers.push(marker);
      });
      this.setBounds(stores);
    }
  },
  openInfowindow: function(marker) {
    this.infowindow.setContent(marker.content);
    this.infowindow.open(this.map, marker);
  },
  setBounds: function(stores) {
    if (stores.length > 1) {
      this.bounds = new google.maps.LatLngBounds();
      stores.forEach(function(store) {
        var latlng = { lat: store.latitude, lng: store.longitude };
        storeLocator.bounds.extend(latlng);
      });
      this.map.fitBounds(this.bounds);
    } else {
      this.map.setCenter({ lat: stores[0].latitude, lng: stores[0].longitude });
      this.map.setZoom(12);
    }
  },
  setStores: function(stores) {
    stores.map(function(store) {
      var addressParts = store.address.split(", ");
      var storeState = addressParts[addressParts.length - 1];
      if (storeLocator.states.indexOf(storeState) > -1) {
        store.state = storeState;
      }
      return store;
    });
    this.stores = stores;
    storeLocator.initMarkers(stores);
  },
  initAccordion: function(stores) {
    this.accordion.empty();
    $(stores).each(function() {
      storeLocator.accordion.append(storeLocator.accordionItem(this));
    });
  },
  storeHoursMarkup: function(store) {
    var storeHourKeys = Object.keys(this.storeHours);
    var storeSlug = store.custom_field_1.replace("/pages/", "");
    var storeHoursIndex = storeHourKeys[storeHourKeys.indexOf(storeSlug)];
    var storeHours = this.storeHours[storeHoursIndex];

    var storeHoursNames = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

    var $storeHoursEl = $("<dl></dl>");

    storeHoursNames.forEach(function(key) {
      if (storeHours && storeHours[key]) {
        $storeHoursEl.append("<dt>" + storeHours[key + "_label"] + "</dt>");
        $storeHoursEl.append("<dd>" + storeHours[key] + "</dd>");
      }
    });

    return $storeHoursEl;
  },
  accordionItem: function(store) {
    var $accordionItem = $(
      "<div class='map-accordion-item' data-state='" +
        store.state +
        "'>" +
        "<button class='map-accordion-header' aria-expanded='false' data-store-id='" +
        store.id +
        "'>" +
        "<h2>" +
        store.name +
        "</h2>" +
        "</button>" +
        "<div class='map-accordion-body' aria-hidden='true'>" +
        "<ul class='map-accordion-data store-locator-data'>" +
        "<li><a><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'><use href='#phone'></svg>" +
        store.phone +
        "</a></li>" +
        "<li><address><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'><use href='#locator-pin'></svg>" +
        store.address +
        "</address></li>" +
        "</ul>" +
        "<h3>Opening Hours</h3>" +
        "<dl>" +
        storeLocator.storeHoursMarkup(store).html() +
        "</dl>" +
        "<div class='map-button-wrapper'>" +
        "<a href='" +
        store.custom_field_1 +
        "' class='c-btn c-btn--ghost_2'>View</a>" +
        "<a href='http://maps.google.com/maps?saddr=&daddr=" +
        encodeURIComponent(store.address) +
        "' class='c-btn c-btn--dark' target='_blank' rel='nofollow noopener'>Directions</a>" +
        "</div>" +
        "</div>" +
        "</div>"
    );

    $accordionItem.find(".map-accordion-header").click(function() {
      var open = $(this).attr("aria-expanded") === "true";
      $(this).attr("aria-expanded", !open);
      $accordionItem.find(".map-accordion-body").attr("aria-hidden", open);
      if (open) {
        return;
      }
      var markerID = $(this).data("store-id");
      if (storeLocator.map && storeLocator.markers.length) {
        var marker = storeLocator.markers.filter(function(marker) {
          if (marker.id == markerID) {
            storeLocator.map.setCenter(marker.position);
            storeLocator.map.setZoom(12);
            storeLocator.openInfowindow(marker);
          }
        });
      }
    });

    return $accordionItem;
  },
  initButtons: function() {
    this.filterHeading.click(function() {
      var open = storeLocator.filterStates.attr("aria-hidden") === "false";
      storeLocator.filterStates.attr("aria-hidden", open ? "true" : "false");
    });
    this.filters.click(function() {
      storeLocator.filters.attr("aria-selected", false);
      $(this).attr("aria-selected", true);
      storeLocator.filterState(this.value);
    });
  },
  filterState: function(state) {
    if (state === "All") {
      this.initAccordion(this.stores);
      if (this.map) {
        this.markers.forEach(function(marker) {
          marker.setMap(storeLocator.map);
        });
        this.setBounds(this.stores);
      }
    } else {
      var stores = this.stores.filter(function(store) {
        return store.state === state;
      });
      this.initAccordion(stores);
      if (this.map) {
        this.markers.forEach(function(marker) {
          if (marker.state === state) {
            marker.setMap(storeLocator.map);
          } else {
            marker.setMap(null);
          }
        });
        this.setBounds(
          this.stores.filter(function(store) {
            return store.state === state;
          })
        );
      }

      this.accordion
        .find(".map-accordion-item[data-state='" + state + "']")
        .show();
    }
  },
  geocode: function(query, then) {
    var postcode = query.match(/\d{1,4}/);
    if (postcode !== null) {
      var queryString = "&components=country:AU|postal_code:" + postcode;
    } else {
      var queryString = "&components=country:AU|locality:" + query;
    }
    $.ajax(
      "https://maps.googleapis.com/maps/api/geocode/json?key=" +
        this.apiKey +
        queryString,
      {
        success: function(resp) {
          if (resp.status === "ZERO_RESULTS") {
            if (postcode !== -1) {
              storeLocator.searchError("No results for postcode " + postcode);
            } else {
              storeLocator.searchError("No results for query " + query);
            }
          } else if (!resp.results || resp.results.length === 0) {
            storeLocator.searchError(
              "Error finding coordinates for search term"
            );
          }
          if (then && typeof then === "function") {
            then(resp.results[0].geometry.location);
          }
        }
      }
    );
  },
  searchError: function(error) {
    alert(error);
  },
  filterStoresByLocation: function(location) {
    location = new google.maps.LatLng(location.lat, location.lng);
    var stores = storeLocator.stores
      .slice()
      .sort(function(a, b) {
        var aDistance = google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(a.latitude, a.longitude),
          location
        );
        var bDistance = google.maps.geometry.spherical.computeDistanceBetween(
          new google.maps.LatLng(b.latitude, b.longitude),
          location
        );
        return aDistance - bDistance;
      })
      .slice(0, storeLocator.maxResults);
    storeLocator.initAccordion(stores);
    storeLocator.markers.map(function(marker) {
      marker.setMap(null);
      return null;
    });
    storeLocator.initMarkers(stores);
    $(".map-accordion-item:first-child button").click();
    $(".map-accordion-item:first-child button").focus();
  },
  initSearch: function() {
    if ($(window).width() < 768) {
      this.input.attr("placeholder", "Suburb/Postcode");
    }
    this.form.on("submit", function(e) {
      e.preventDefault();
      if (storeLocator.infowindow) {
        storeLocator.infowindow.setMap(null);
      }
      storeLocator.geocode(
        storeLocator.input.val(),
        storeLocator.filterStoresByLocation
      );
    });
  }
};
if ($("#shopify-section-store-locator").length > 0) {
  storeLocator.init();
}

// Plus Change - Support Multiple Sliders - LC 26 June 2020
var productGridButton = document.querySelectorAll(".product-grid-section-next-button");
var productGrid = document.querySelectorAll(".product-grid-section-grid");

for (var i = 0; i < productGridButton.length; i++) {
  productGridButton[i].setAttribute("data-currentGridPosition", 0);
  
  productGridButton[i].addEventListener("click", function (e) {
    var gridItems = e.target.parentElement.querySelectorAll(".product-grid-section-item");
    var currentGridPosition = Number(e.target.getAttribute("data-currentGridPosition"));
    currentGridPosition++;

    if (window.innerWidth > 981) {
      if (currentGridPosition > 4) {
        currentGridPosition = 0;
      }
    } else {
      if (currentGridPosition > 5) {
        currentGridPosition = 0;
      }
    }

    for (var j = 0; j < gridItems.length; j++) {
      var product = gridItems[j];
      product.style.transform =
        "translateX(" + -(100 * currentGridPosition) + "%)";
    }

    e.target.setAttribute("data-currentGridPosition", currentGridPosition);
  });
}
$(document).ready(function () {
  $('.stores-option li').click(function () {
    let data = $(this).attr('data-option')
    $('.store-option').removeClass('active')
    $('.stores-list').hide()
    $(this).addClass('active')
    $(`.stores-list[data-option="${data}"]`) .css("display", "grid").hide().fadeIn();
  })
});

if (window.innerWidth < 768) {
    if($('.header__search .search__form-input')){
      $('.clear-cross.clear-query-autocomplete').hide();
      $('.clear-cross.clear-query-autocomplete').click(function () {
         document.getElementById('boost-pfs-search-box-0').value = '';
         $(this).hide();
      });
      $(".header__search .search__form-input").on("input", function() {
        if($(this).val() == '') {
           $('.clear-cross.clear-query-autocomplete').hide();
        } else {
           $('.clear-cross.clear-query-autocomplete').show();
           $('body').addClass('fill-search');
        }
      });
    }
}
